import { useQuery } from "@tanstack/react-query";
import { Link, createFileRoute } from "@tanstack/react-router";

import { requireAuth } from "@/middleware/auth";
import { useFavoriteListQuery } from "@/queries/favorite";
import { BookOpen } from "lucide-react";

export const Route = createFileRoute("/")({
	beforeLoad: async () => {
		await requireAuth();
	},
	component: App,
});

function App() {
	const queryOptions = useFavoriteListQuery();
	const { data } = useQuery(queryOptions);

	return (
		<div className="container mx-auto px-4">
			<h3 className="font-medium mb-1">자주쓰는 자료</h3>
			<ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
				{data?.slice(0, 5).map((favorite) => (
					<li key={favorite.pack_id} className="aspect-video">
						<Link
							to="/pack/$pack_id"
							params={{ pack_id: favorite.pack_id }}
							className="block size-full bg-white overflow-hidden"
						>
							<img
								src={favorite.pack_thumbnail_url}
								alt={favorite.pack_name}
								className="size-full object-contain bg-white"
							/>
						</Link>
					</li>
				))}
				<li className="aspect-video bg-white flex flex-col items-center justify-center">
					<Link
						to="/pack"
						className="size-full flex flex-col items-center justify-center"
					>
						<BookOpen className="size-12 mb-2 text-gray-400" />
						<p className="text-gray-800 font-semibold text-2xl">
							전체 설명서 보기
						</p>
					</Link>
				</li>
			</ul>
		</div>
	);
}
